import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useAddAdminSpamAccountMutation } from "@/redux/services/adminSpamAccountsApi"
import { setToast } from "@/redux/toastSlice"
import type { AddSpamAccountPayload } from "@/types/entities/spam-account"

export const useAddSpamAccount = () => {
  const dispatch = useAppDispatch()
  const [addGsuiteAccount, response] = useAddAdminSpamAccountMutation()

  const handleAddSpamAccount = async (body: AddSpamAccountPayload) => {
    try {
      const response = await addGsuiteAccount(body).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success add account",
          }),
        )
      }
      return response
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error()
    }
  }

  return { addSpamAccount: handleAddSpamAccount, response }
}
